import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Stack,
} from "@mui/material";
import { styled } from "@mui/material/styles";

export const Root = styled(Stack)({
  width: "100%",
});

export const Item = styled(Accordion)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
  boxShadow: "none",
  backgroundImage: "none",
  "&:before": {
    display: "none",
  },
  "&.Mui-expanded": {
    margin: 0,
  },
  "& + &": {
    marginTop: theme.spacing(1),
  },
}));

export const Summary = styled(AccordionSummary)(({ theme }) => ({
  minHeight: 48,
  padding: theme.spacing(0, 2),
  "&.Mui-expanded": {
    minHeight: 48,
  },
  "& .MuiAccordionSummary-content": {
    margin: theme.spacing(1.5, 0),
  },
  "& .MuiAccordionSummary-content.Mui-expanded": {
    margin: theme.spacing(1.5, 0),
  },
  [theme.breakpoints.down("md")]: {
    minHeight: 52,
    "&.Mui-expanded": {
      minHeight: 52,
    },
    "& .MuiAccordionSummary-content": {
      margin: theme.spacing(1.75, 0),
    },
    "& .MuiAccordionSummary-content.Mui-expanded": {
      margin: theme.spacing(1.75, 0),
    },
  },
}));

export const Details = styled(AccordionDetails)(({ theme }) => ({
  padding: theme.spacing(0, 2, 2),
}));
